var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elements/Symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M42.223 35.5312L34.8298 21.8589C35.584 20.147 36.006 18.2551 36.006 16.2646C36.006 8.59336 29.787 2.375 22.1164 2.375C14.4439 2.375 8.22555 8.59399 8.22555 16.2646C8.22555 18.3031 8.66837 20.2373 9.45672 21.9808L2.03058 35.5248C1.79113 35.9601 1.83092 36.497 2.13034 36.8943C2.4304 37.2905 2.93701 37.4768 3.42085 37.3631L9.76237 35.9083L11.9329 41.9536C12.1022 42.4236 12.5311 42.7495 13.0282 42.7862C13.0605 42.7887 13.0914 42.7899 13.1217 42.7899C13.3501 42.7899 13.5743 42.7278 13.7703 42.6105C13.9663 42.4931 14.1268 42.3248 14.2347 42.1235L20.6975 30.0829C21.1688 30.1306 21.6421 30.1545 22.1157 30.1543C22.5547 30.1543 22.988 30.1315 23.4163 30.0911L30.0194 42.133C30.1362 42.3465 30.3122 42.5216 30.5263 42.6374C30.7403 42.7531 30.9833 42.8046 31.2259 42.7855C31.7218 42.7457 32.1488 42.4204 32.3168 41.953L34.4872 35.9077L40.8288 37.3625C41.3152 37.4799 41.8167 37.291 42.1168 36.8962C42.4181 36.5021 42.4586 35.9677 42.223 35.5312Z",
    fill: "url(#paint0_linear_115_7234)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_7234",
    x1: 2,
    y1: 14,
    x2: 42,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205826,
    stopColor: "#FFE479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779701,
    stopColor: "#FACE1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolIcon);
export default __webpack_public_path__ + "static/media/SymbolIcon.36bb6f1b435260ffa00bff3ca223fe4c.svg";
export { ForwardRef as ReactComponent };